export default __webpack_public_path__ + "static/media/User.1aa2305e.svg";